import React from "react";
import {
    AUDIO_WAVE_IMAGE_HEIGHT,
    AUDIO_WAVE_IMAGE_WIDTH,
    ImagePreview,
    MAX_VIDEO_HEIGHT,
    MAX_VIDEO_WIDTH,
} from "pages/MaterialSpecs/components/PreviewSelector";
import { HtmlPreview } from "pages/MaterialSpecs/components/PreviewSelector/HtmlPreview/HtmlPreview";
import { AudioVideoPreview } from "pages/MaterialSpecs/components/PreviewSelector/AudioVideoPreview/AudioVideoPreview";
import { MaterialType } from "pages/MaterialSpecs/components";
import { PdfPreview } from "./PdfPreview/PdfPreview";

interface PreviewSelectorProps {
    preview: string;
    type: MaterialType;
    width: number;
    height: number;
}

export const PreviewSelector = ({ preview, type, width, height }: PreviewSelectorProps) => {
    switch (type) {
        case "HTML": {
            return <HtmlPreview path={preview} />;
        }

        case "AUDIO": {
            return (
                <AudioVideoPreview
                    path={preview}
                    width={AUDIO_WAVE_IMAGE_WIDTH}
                    height={AUDIO_WAVE_IMAGE_HEIGHT}
                    isAudio
                />
            );
        }
        case "VIDEO": {
            return (
                <AudioVideoPreview
                    path={preview}
                    width={width > MAX_VIDEO_WIDTH ? MAX_VIDEO_WIDTH : width}
                    height={height > MAX_VIDEO_HEIGHT ? MAX_VIDEO_HEIGHT : height}
                />
            );
        }

        case "EPS":
        case "PDF": {
            return <PdfPreview />;
        }

        default: {
            return <ImagePreview path={preview} />;
        }
    }
};
